/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1669593600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Mon Nov 28 2022 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "gong",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Setup",
          "depth": 0,
          "id": "setup"
        }, {
          "value": "Select CRM integration",
          "depth": 0,
          "id": "select-crm-integration"
        }, {
          "value": "Syncing CRM data",
          "depth": 0,
          "id": "syncing-crm-data"
        }, {
          "value": "Upload CRM data",
          "depth": 1,
          "id": "upload-crm-data"
        }, {
          "value": "Field mapping",
          "depth": 1,
          "id": "field-mapping"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      a: "a",
      img: "img",
      h3: "h3",
      ul: "ul",
      li: "li"
    }, _provideComponents(), props.components), {NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "setup",
        children: "Setup"
      }), "\n", _jsx(_components.p, {
        children: "To get started with Gong, create an integration with Gong, and use your Access Token and Secret to create a new destination within Hightouch."
      }), "\n", _jsxs(_components.p, {
        children: ["The Gong API page can be found here: (", _jsx(_components.a, {
          href: "https://app.gong.io/company/api",
          children: "https://app.gong.io/company/api"
        }), ")."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-gong-setup.png",
          alt: ""
        })
      }), "\n", _jsx(_components.h2, {
        id: "select-crm-integration",
        children: "Select CRM integration"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch allows you to choose which CRM integration you wish to sync data to. This can be selected on the sync configuration page."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-gong-integration.png",
          alt: ""
        })
      }), "\n", _jsx(_components.h2, {
        id: "syncing-crm-data",
        children: "Syncing CRM data"
      }), "\n", _jsx(_components.h3, {
        id: "upload-crm-data",
        children: "Upload CRM data"
      }), "\n", _jsx(_components.p, {
        children: "The Gong integration allows users to upsert the following object types:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "CRM Users"
        }), "\n", _jsx(_components.li, {
          children: "Accounts"
        }), "\n", _jsx(_components.li, {
          children: "Deals"
        }), "\n", _jsx(_components.li, {
          children: "Contacts"
        }), "\n", _jsx(_components.li, {
          children: "Leads"
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync columns from your source to Gong's fields."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-gong-mappings.png",
          alt: ""
        })
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
